import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

// Lead Metrics team tabs (Nic 2026-10-01). period = '2026', '2026-Q4',
// '2026-10' or '2026-10-03~2026-10-09' (Central); empty = this quarter.
// filter = the Source menu, the same one the Funnel uses (2026-10-25):
// { source, partnerId }, empty = all sources. Admins and the Onboarding
// Manager only.
const useTeamMetrics = (team, period, filter = {}, opts = {}) =>
  useQuery(
    ['team-metrics', team, period || 'current', filter.source || '', filter.partnerId || ''],
    async () => {
      const res = await axios.get(`/onboarding-board/team-metrics/${team}`, {
        params: {
          ...(period ? { period } : {}),
          ...(filter.source ? { source: filter.source } : {}),
          ...(filter.partnerId ? { partnerId: filter.partnerId } : {}),
        },
      });
      return res.data;
    },
    {
      keepPreviousData: true,
      staleTime: 60000,
      refetchOnWindowFocus: false,
      ...opts,
    },
  );

export const useSalesTeamMetrics = (period, filter, opts) => useTeamMetrics('sales', period, filter, opts);
export const useOnboardingTeamMetrics = (period, filter, opts) =>
  useTeamMetrics('onboarding', period, filter, opts);
